module.exports = __webpack_public_path__ + "static/media/background.33dfcc9a.jpg";